// extracted by mini-css-extract-plugin
export default {"filtersSection":"filtersSection__EpigenomeFilters__ucBF3","filtersSectionBody":"filtersSectionBody__EpigenomeFilters__ucBF3"};